import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import Side from "./components/side/Side";
import Posts from "./features/posts/Posts";
import Search from "./features/Search";
import HomeScreen from "./screens/HomeScreen";

function App() {
  const [active, setActive] = useState(false);
  function handleToggleClick() {
    setActive(!active);
  }
  return (
    <BrowserRouter>
      <div className="contents">
        <div>
          <Header handleToggleClick={handleToggleClick} />
        </div>
        <div className="content">
          <div className={active ? "subreddits active" : "subreddits"}>
            <Side handleToggleClick={handleToggleClick} />
          </div>
          <div className="main ">
            <Routes>
              <Route path="/" element={<HomeScreen />} exact></Route>
              <Route path="/r/:subreddit" element={<Posts />}></Route>
              <Route path="/search/" element={<Search />}></Route>
            </Routes>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
